import { render, staticRenderFns } from "./ChannelManagementRegionView.vue?vue&type=template&id=457c0991&"
import script from "./ChannelManagementRegionView.vue?vue&type=script&lang=js&"
export * from "./ChannelManagementRegionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports